'use client';

import { DISCORD, TWITTER } from '@frontend/common';
import { Flex, IconButton, Link, Text } from '@radix-ui/themes';
import { FaDiscord, FaXTwitter } from 'react-icons/fa6';

const navigation = {
  social: [
    {
      name: 'Discord',
      href: DISCORD,
      icon: FaDiscord,
    },
    {
      name: 'Twitter',
      href: TWITTER,
      icon: FaXTwitter,
    },
  ],
};

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[var(--color-background)]">
      <Flex mt="8" justify="between" px="4" py="2" align="center">
        <Text size="1" color="gray">
          &copy; {currentYear} yodl ·
          <Link
            href="https://about.yodl.me/c/legal/terms-of-use"
            target="_blank"
            color="gray"
            className="hover:text-blue-500"
          >
            ToU
          </Link>{' '}
          ·
          <Link
            href="https://about.yodl.me/c/legal/privacy-policy"
            target="_blank"
            color="gray"
            className="hover:text-blue-500"
          >
            Privacy
          </Link>
        </Text>

        <div className="flex items-center">
          {navigation.social.map((item) => (
            <a
              key={item.name}
              href={item.href || '#'}
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconButton
                size="1"
                variant="ghost"
                ml="2"
                color="gray"
                className="hover:opacity-70 transition-opacity !m-0"
              >
                <item.icon aria-hidden="true" />
              </IconButton>
            </a>
          ))}
        </div>
      </Flex>
    </footer>
  );
}
